import { fromPairs } from 'lodash';
import { useMemo } from 'react';
import { useLocation } from 'react-router';

export const useQuery = <T extends object>() => {
    const { search } = useLocation();

    return useMemo(() => fromPairs(Array.from(new URLSearchParams(search).entries())) as T, [search]);
};
